import * as React from "react";
import Dropdown from "../../../../../components/general/Dropdown.tsx";
import {DEFAULT_SORT_OPTION} from "./unmatchedTransactionsUtils.ts";
import {SortOption, SortOptionsEnum} from "./types.ts";

export const SORT_OPTIONS: SortOption[] = [
    {value: SortOptionsEnum.DATE_ASC, label: "Datum: oudste eerst"},
    {value: SortOptionsEnum.DATE_DESC, label: "Datum: nieuwste eerst"},
    {value: SortOptionsEnum.AMOUNT_ASC, label: "Bedrag: laagste eerst"},
    {value: SortOptionsEnum.AMOUNT_DESC, label: "Bedrag: hoogste eerst"},
];

interface BusinessCardSortProps {
    selectedSort: SortOptionsEnum;
    onSortChange: (sortOption: SortOptionsEnum) => void;
}

export function BusinessCardSort({
    selectedSort,
    onSortChange,
}: BusinessCardSortProps) {
    const selectedOption =
        SORT_OPTIONS.find(option => option.value === selectedSort) ??
        SORT_OPTIONS.find(option => option.value === DEFAULT_SORT_OPTION) ??
        SORT_OPTIONS[0];

    return (
        <div className="w-56">
            <Dropdown
                selected={{value: selectedOption.value, label: selectedOption.label}}
                options={SORT_OPTIONS}
                onUpdateFunc={(value) => onSortChange(value as SortOptionsEnum)}
            />
        </div>
    );
}
